import { Navigate, Outlet } from 'react-router-dom';
import { ReactElement } from 'react';
import { UserRole } from '@synergy/models';
import { hasRole } from '@synergy/utils';

import { useAppSelector } from '../../../store/store';
import { userSelector } from '../../store/configuration-selectors';

interface RouteAccessControlProps {
    redirectTo: string;
}

export const RouteAccessControl = (props: RouteAccessControlProps): ReactElement | null => {
    const user = useAppSelector(userSelector);

    if (!user) {
        return null;
    }

    if (hasRole([UserRole.ShopAdmin, UserRole.ShopUser], user)) {
        return <Outlet />;
    }

    if (hasRole([UserRole.SupplierAdmin, UserRole.Extranet], user)) {
        return <Navigate to={props.redirectTo} replace={true} />;
    }

    return null;
};
